import React from "react";
import { connect } from "react-redux";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ClipLoader from "react-spinners/ClipLoader";

import { PlansDownload, PDFDownloader } from "@safecv/actions/postActions";
import { downloadBlock } from "@safecv/shared/sharedFunction";
import download from "@safecv/assets/Images/download-sow3.svg";

const DownloadMenuComponent = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const {
    PlansDownload,
    pdfTypesLoader,
    planType,
    PDFDownloader,
    jobId,
    headerHeight,
  } = props;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    PlansDownload(jobId);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <img
        src={download}
        alt=""
        className="header-download-option"
        aria-controls="download-menu"
        aria-haspopup="true"
        onClick={handleClick}
      />
      <Menu
        id="download-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: headerHeight - headerHeight / 3.9,
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            borderRadius: "5px",
          },
        }}
      >
        {pdfTypesLoader ? (
          <ClipLoader
            css={downloadBlock}
            size={15}
            color={"#4183C5"}
            loading={pdfTypesLoader}
          />
        ) : (
          planType.map((option) => {
            return (
              <div className="download-plan-list" key={option.name}>
                <MenuItem
                  style={{
                    textDecorationLine: "underline",
                    pointerEvents: "auto",
                    color: "#4183C5",
                  }}
                  disabled={!option.active || props.pdfTypes[option.type]}
                  onClick={() => option.active && PDFDownloader(option.url)}
                  title={option.description}
                >
                  {option.name}
                </MenuItem>
                <ClipLoader
                  size={15}
                  color={"#4183C5"}
                  loading={props.pdfTypes[option.type]}
                />
              </div>
            );
          })
        )}
      </Menu>
    </div>
  );
};

const mapStatetoProps = (state) => {
  return {
    pdfTypes: state.plans.pdfTypes,
    pdfTypesLoader: state.plans.pdfTypesLoader,
    planType: state.plans.file_type,
  };
};

const mapDispatchtoProps = (dispatch) => {
  return {
    PlansDownload: (jobId) => {
      dispatch(PlansDownload(jobId));
    },
    PDFDownloader: (url) => {
      dispatch(PDFDownloader(url));
    },
  };
};

export default connect(
  mapStatetoProps,
  mapDispatchtoProps
)(DownloadMenuComponent);
